export default "__VITE_ASSET__DLpdSjdg__"